import LegacyButton from "legacy/LegacyButton"
import {
  centsToDollars,
  formatPriceForCategory,
  humanize,
  isEmpty,
  metaFuel,
} from "legacy/helpers.es6"
import Chip from "legacy/manage/Chip"
import DiscountDropdown from "legacy/sales/DiscountDropdown"
import QuantityIncrementer from "legacy/sales/QuantityIncrementer"
import QuantityInput from "legacy/sales/QuantityInput"
import PropTypes from "prop-types"
import React from "react"

class SaleCheckoutItem extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      discountDropdownOpen: false,
    }
    this.validateClasses = this.validateClasses.bind(this)
    this.toggleDiscountDropdownOpen = this.toggleDiscountDropdownOpen.bind(this)
    this.handleInputQuantity = this.handleInputQuantity.bind(this)
    this.handleIncrementQuantity = this.handleIncrementQuantity.bind(this)
    this.addDiscount = this.addDiscount.bind(this)
    this.removeDiscount = this.removeDiscount.bind(this)
    this.renderCheckoutItemName = this.renderCheckoutItemName.bind(this)
    this.renderPrice = this.renderPrice.bind(this)
    this.renderSelectedDiscounts = this.renderSelectedDiscounts.bind(this)
    this.renderDiscountOption = this.renderDiscountOption.bind(this)
    this.renderDiscountDropdown = this.renderDiscountDropdown.bind(this)
    this.renderRemoveButton = this.renderRemoveButton.bind(this)
    this.renderQuantityAdjuster = this.renderQuantityAdjuster.bind(this)
    this.renderQuantityError = this.renderQuantityError.bind(this)
  }

  validateClasses(itemId) {
    if (this.props.invalidItems.find((item) => item.id === itemId)) {
      return "border-red rounded focus:ring focus:ring-red-500 focus:ring-4 focus:outline-none"
    }
  }

  toggleDiscountDropdownOpen() {
    this.setState({ discountDropdownOpen: !this.state.discountDropdownOpen })
  }

  handleInputQuantity(quantity) {
    const item = this.props.item
    // Note: metaFuel is loaded globally
    const precision = metaFuel(item.category) ? 4 : 2
    const wholeNumberAndDecimals = quantity.split(".")
    let finalQuantity = quantity
    // checks if quantity has decimals and truncates decimals to precision
    if (
      wholeNumberAndDecimals.length !== 1 &&
      wholeNumberAndDecimals[1].length > precision
    ) {
      const decimals = wholeNumberAndDecimals[1].substring(0, precision)
      finalQuantity = [wholeNumberAndDecimals[0], decimals].join(".")
    }
    item.quantity = finalQuantity
    this.props.handleUpdateItemInCart(item)
  }

  handleIncrementQuantity(quantity) {
    this.props.handleUpdateItemInCart({ ...this.props.item, quantity })
  }

  addDiscount(discount) {
    this.setState({ discountDropdownOpen: false })
    // Note: Amplitude is loaded globally
    Amplitude.trackEvent("web_pos:item_discount_used")
    this.props.handleUpdateItemInCart({
      ...this.props.item,
      discounts: [discount],
    })
  }

  removeDiscount() {
    this.props.handleUpdateItemInCart({ ...this.props.item, discounts: [] })
  }

  renderCheckoutItemName() {
    // Note: humanize is loaded globally
    return <div>{humanize(this.props.item.name)}</div>
  }

  renderPrice() {
    // Note: metaFuel, centsToDollars, formatPriceForCategory are loaded globally
    if (metaFuel(this.props.item.category) && this.props.item.quantity === "") {
      return <div className="font-semibold">$0.00</div>
    } else if (!this.props.fetchedItem || this.props.loadingPrices) {
      return (
        <span className="text-center text-gray-600">
          <i className="icon icon-spinner icon-spin" />
        </span>
      )
    } else if (
      this.props.fetchedItem &&
      !isEmpty(this.props.fetchedItem.namedDiscounts)
    ) {
      return (
        <div className="flex">
          {$context.discountsEnabled &&
            !isEmpty(this.props.fetchedItem.namedDiscounts) && (
              <div className="mx-2 line-through">
                {centsToDollars(this.props.fetchedItem.basePreTaxAmount)}
              </div>
            )}
          <div className="font-semibold">
            {formatPriceForCategory(this.props.fetchedItem.preTaxAmount)}
          </div>
        </div>
      )
    } else {
      return (
        <div className="font-semibold">
          {centsToDollars(this.props.fetchedItem.preTaxAmount)}
        </div>
      )
    }
  }

  renderSelectedDiscounts() {
    return (
      <div className="my-1 flex w-full flex-row">
        {this.props.item.discounts.map((discount) => (
          <div
            key={discount.encodedId}
            className={"flex-initial"}
            style={{ maxWidth: "10rem" }}
          >
            <Chip
              text={discount.displayText}
              onClick={() => this.removeDiscount()}
              icon={"icon icon-close-mdc"}
              iconSize={"1em"}
              style="teal"
            />
          </div>
        ))}
      </div>
    )
  }

  renderDiscountOption(discount) {
    return (
      <div key={discount.encodedId}>
        <button
          type="button"
          className="flex items-center bg-white hover:bg-gray-200"
          onClick={() => this.addDiscount(discount)}
        >
          {discount.displayText}
        </button>
      </div>
    )
  }

  renderDiscountDropdown() {
    return (
      <DiscountDropdown
        open={this.state.discountDropdownOpen}
        toggleOpen={this.toggleDiscountDropdownOpen}
      >
        {this.props.discountOptions.map((discount) =>
          this.renderDiscountOption(discount)
        )}
      </DiscountDropdown>
    )
  }

  renderRemoveButton() {
    return (
      <div className="mr-2">
        <LegacyButton
          className="btn-sm mr-2"
          type="tertiary"
          iconOnly={true}
          icon="icon-times text-xs"
          aria-label="remove from cart"
          onClick={() => this.props.handleRemoveFromCart(this.props.item)}
        />
      </div>
    )
  }

  renderQuantityAdjuster() {
    // Note: metaFuel is loaded globally
    if (metaFuel(this.props.item.category)) {
      return (
        <QuantityInput
          item={this.props.item}
          validationClasses={this.validateClasses(this.props.item.id)}
          handleInputQuantity={this.handleInputQuantity}
        />
      )
    } else {
      return (
        <QuantityIncrementer
          item={this.props.item}
          validationClasses={this.validateClasses(this.props.item.id)}
          handleInputQuantity={this.handleInputQuantity}
          handleIncrementQuantity={this.handleIncrementQuantity}
        />
      )
    }
  }

  renderQuantityError() {
    return (
      <div className="my-1 flex w-full flex-row justify-end">
        <p className="text-status-red">
          {" "}
          Item must have quantity greater than 0
        </p>
      </div>
    )
  }

  render() {
    return (
      <div className="my-2 flex w-full flex-col">
        <div className="my-1 flex w-full flex-row">
          <div>{this.renderCheckoutItemName()}</div>
          <div className="flex flex-1 justify-end">{this.renderPrice()}</div>
        </div>
        {$context.discountsEnabled &&
          !isEmpty(this.props.item.discounts) &&
          this.renderSelectedDiscounts()}
        <div className="my-1 flex w-full flex-row justify-between">
          <div className="flex items-center">
            {$context.discountsEnabled &&
              !isEmpty(this.props.discountOptions) &&
              this.renderDiscountDropdown()}
          </div>
          <div className="flex flex-1 justify-end">
            {this.renderRemoveButton()}
            <div>{this.renderQuantityAdjuster()}</div>
          </div>
        </div>
        {this.props.showQuantityError && this.renderQuantityError()}
      </div>
    )
  }
}

SaleCheckoutItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    category: PropTypes.string,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    discounts: PropTypes.array,
  }).isRequired,
  fetchedItem: PropTypes.object,
  loadingPrices: PropTypes.bool,
  invalidItems: PropTypes.array,
  discountOptions: PropTypes.array,
  showQuantityError: PropTypes.bool,
  handleUpdateItemInCart: PropTypes.func.isRequired,
  handleRemoveFromCart: PropTypes.func.isRequired,
}

SaleCheckoutItem.defaultProps = {
  invalidItems: [],
  discountOptions: [],
  showQuantityError: false,
}

export default SaleCheckoutItem
